import React from 'react';
import {Grid} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import {convertToInt} from '@utils/helpers';
import {columns} from '@modules/events/components/Table/EventContentMultiAudio/EventContentMultiAudioTable';
import {hasPrivileges} from '@appComponents/Authorization';
import * as RESOURCES from '@constants/resources';
import * as CONST from '@constants/variables';
import {
    ButtonsForEditableRowInViewMode,
} from '@modules/events/components/Table/EventContentMultiAudio/ButtonsForEditableRowInViewMode';
import {getStreamLanguageById} from '@modules/events/utils/eventContentHelper';

export const EditableGrids = ({data, encodingTargetId, setActiveEditableFields, ...props}) => {
    const isEditable = hasPrivileges({[RESOURCES.AUDIO]: CONST.SECURITY_PRIVILEGES_UPDATE});
    const gridClass = isEditable ? 'editableTable__trigger --audio_modal_row' : '--audio_modal_row';
    const handleClick = isEditable ? () => setActiveEditableFields(convertToInt(data.id)) : null;

    return (
        <Grid verticalAlign='middle'>
            <Grid.Row data-id={data.id} onClick={handleClick} className={gridClass}>
                <Grid.Column width={columns.tracks.width}>{data.track_number}</Grid.Column>
                <Grid.Column width={columns.channels.width}>{data.channels?.toString()}</Grid.Column>
                <Grid.Column width={columns.streamLanguage.width}>
                    {getStreamLanguageById(data.stream_language?.id, props.DataEventContentMultiAudio.streamLanguages)}
                </Grid.Column>
                <Grid.Column width={columns.actions.width}>
                    <ButtonsForEditableRowInViewMode
                        data={data}
                        encodingTargetId={encodingTargetId}
                        deleteMutation={props.DeleteMutation}
                        addMessage={props.MessageBox.addMessage}
                    />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

EditableGrids.propTypes = {
    data: PropTypes.object.isRequired,
    setActiveEditableFields: PropTypes.func.isRequired,
    DeleteMutation: PropTypes.func.isRequired,
    MessageBox: PropTypes.object.isRequired,
    DataEventContentMultiAudio: PropTypes.object.isRequired,
    encodingTargetId: PropTypes.number.isRequired,
};
